module.exports = __webpack_public_path__ + "img/enlarge.a6932f44.png";